import Api from './Api';

class LogicBaseUserReportApi extends Api {
  url = 'logicbaseuserreports';
}

const singleton = new LogicBaseUserReportApi();
export default singleton;
